declare namespace $ {

	export class $mol_icon_format_vertical_align_bottom extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=bottom.view.tree.d.ts.map